const AUTH_BASE_URL = (process.env.REACT_APP_AUTH_SERVICE_URL || 'http://localhost:3001').replace(/\/$/, '');

const withJson = (body) => {
  const config = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    credentials: 'include',
  };
  if (body && Object.keys(body).length > 0) {
    config.body = JSON.stringify(body);
  }
  return config;
};

const handleResponse = async (response) => {
  if (response.status === 204) {
    return null;
  }
  const text = await response.text();
  if (text.length === 0) {
    if (!response.ok) {
      throw new Error('Error desconocido en el servicio de autenticación');
    }
    return null;
  }

  let payload;
  try {
    payload = JSON.parse(text);
  } catch (error) {
    payload = { message: text };
  }

  if (!response.ok) {
    const message = payload?.message || 'Error desconocido en el servicio de autenticación';
    throw new Error(message);
  }

  return payload;
};

export const register = (data) =>
  fetch(`${AUTH_BASE_URL}/auth/register`, withJson(data)).then(handleResponse);

export const login = (data) =>
  fetch(`${AUTH_BASE_URL}/auth/login`, withJson(data)).then(handleResponse);

export const exchange = (data) =>
  fetch(`${AUTH_BASE_URL}/auth/token`, withJson(data)).then(handleResponse);

export const refresh = () =>
  fetch(`${AUTH_BASE_URL}/auth/refresh`, withJson()).then(handleResponse);

export const logout = () =>
  fetch(`${AUTH_BASE_URL}/auth/logout`, withJson()).then(handleResponse);

export const enableMfa = () =>
  fetch(`${AUTH_BASE_URL}/auth/mfa/enable`, withJson()).then(handleResponse);

export const confirmMfa = (code) =>
  fetch(`${AUTH_BASE_URL}/auth/mfa/confirm`, withJson({ code })).then(handleResponse);

export const cancelMfa = () =>
  fetch(`${AUTH_BASE_URL}/auth/mfa/cancel`, withJson()).then(handleResponse);

export const verifyMfa = (authorizationCode, code) =>
  fetch(`${AUTH_BASE_URL}/auth/mfa/verify`, withJson({ authorizationCode, code })).then(handleResponse);

export const getAuthBaseUrl = () => `${AUTH_BASE_URL}/auth`;

const authService = {
  register,
  login,
  exchange,
  refresh,
  logout,
  enableMfa,
  confirmMfa,
  cancelMfa,
  verifyMfa,
  getAuthBaseUrl,
};

export default authService;
